var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ui container" },
    [
      _c(
        "div",
        { staticClass: "ui top attached tabular menu" },
        _vm._l(_vm.observationsDetail, function(obs, index) {
          return _c("div", { key: index }, [
            obs.observation.procedure != null
              ? _c(
                  "a",
                  { staticClass: "item active", attrs: { "data-tab": index } },
                  [_vm._v(_vm._s("Variable " + (index + 1)))]
                )
              : _vm._e()
          ])
        }),
        0
      ),
      _vm._v(" "),
      _vm._l(_vm.observationsDetail, function(obs, index) {
        return _c("div", { key: index }, [
          _c(
            "div",
            {
              staticClass: "ui bottom attached tabular segment active",
              attrs: { "data-tab": index }
            },
            [
              obs.observation.procedure.dataProduction != null
                ? _c("div", [
                    obs.observation.procedure.dataProduction.sensors != null
                      ? _c(
                          "div",
                          { staticClass: "sensor-panel" },
                          _vm._l(
                            obs.observation.procedure.dataProduction.sensors,
                            function(sensor, index) {
                              return _c("div", { key: index }, [
                                _c("div", { staticClass: "ui segment" }, [
                                  sensor.model != null
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "ui top left attached label"
                                        },
                                        [_vm._v(_vm._s(sensor.model))]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticClass:
                                            "ui top left attached label"
                                        },
                                        [_vm._v(_vm._s(sensor.name))]
                                      ),
                                  _vm._v(" "),
                                  sensor.manufacturer != null
                                    ? _c("div", [
                                        _vm._v(
                                          "Manufacturer : " +
                                            _vm._s(sensor.manufacturer)
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  sensor.serialNumber != null
                                    ? _c("div", [
                                        _vm._v(
                                          "Serial number : " +
                                            _vm._s(sensor.serialNumber)
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  sensor.sensorType != null
                                    ? _c("div", [
                                        _vm._v(
                                          "Sensor type : " +
                                            _vm._s(
                                              _vm.getI18n(
                                                sensor.sensorType,
                                                "en"
                                              )
                                            )
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  sensor.documents != null
                                    ? _c(
                                        "div",
                                        _vm._l(sensor.documents, function(
                                          document,
                                          index
                                        ) {
                                          return _c("div", { key: index }, [
                                            _c("div", [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(document.type) +
                                                  " -\n                    "
                                              ),
                                              _c("a", {
                                                attrs: {
                                                  href: _vm.getI18n(
                                                    document,
                                                    "en"
                                                  )
                                                }
                                              })
                                            ])
                                          ])
                                        }),
                                        0
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  sensor.calibration != null
                                    ? _c("div", [
                                        _vm._v(
                                          "Calibration : " +
                                            _vm._s(
                                              _vm.getI18n(
                                                sensor.calibration,
                                                "en"
                                              )
                                            )
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  sensor.activityPeriods != null
                                    ? _c(
                                        "div",
                                        _vm._l(sensor.activityPeriods, function(
                                          activityPeriod,
                                          index
                                        ) {
                                          return _c("div", { key: index }, [
                                            _c("div", [
                                              _vm._v(
                                                "From " +
                                                  _vm._s(
                                                    activityPeriod.dateBeg
                                                  ) +
                                                  " to " +
                                                  _vm._s(activityPeriod.dateEnd)
                                              )
                                            ])
                                          ])
                                        }),
                                        0
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  sensor.parametrisationDescription != null
                                    ? _c("div", [
                                        _vm._v(
                                          "Parametrisation description : " +
                                            _vm._s(
                                              _vm.getI18n(
                                                sensor.parametrisationDescription,
                                                "en"
                                              )
                                            )
                                        )
                                      ])
                                    : _vm._e()
                                ])
                              ])
                            }
                          ),
                          0
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ]
          )
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }